import {Tooltip} from 'platform/components';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getDisplayValue} from '../../utils/getDisplayValue';
import {getTooltipProps} from '../../utils/getTooltipProps';

type PlainCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};

export function PlainCellRenderer(props: PlainCellRendererProps) {
  const className = getCellClassName(props.isWrap);
  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      <div className={className}>{getDisplayValue(props.value, props.emptyCellValue)}</div>
    </Tooltip>
  );
}
